import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { PagingComponent } from './paging/paging.component';
import { PagePositionComponent } from './pagePosition/pagePosition.component';


@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    PagingComponent,
    PagePositionComponent
  ],
  exports: [
    PagingComponent,
    PagePositionComponent
  ]
})
export class SJISharedModule { }
